export const IS_TAB = window.innerWidth <= 800;
export const IS_MOBILE = window.innerWidth <= 600;

export const addSpaceBeforeCaps = stringValue =>
  stringValue.split(/(?=[A-Z])/).join(' ');
